export enum FormNameEnum {
  Code = 'code',
  Name = 'name',
  Active = 'active',
}
